import { useEffect, useState } from "react";
import { Tag } from "lucide-react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";

export default function SpecialsPage() {
  const [products, setProducts] = useState(null);

  useEffect(() => {
    api
      .get("/products", { params: { special: true, limit: 100 } })
      .then((r) => setProducts(r.data.products))
      .catch(() => setProducts([]));
  }, []);

  return (
    <div data-testid="specials-page">
      <Seo title="Specials & Promotions" description="Current specials and marked-down school supplies, stationery and textbooks at BTMEDU." />
      <section className="bg-navy text-white relative overflow-hidden">
        <div className="absolute inset-0 hero-grid-lines" />
        <div className="absolute -right-24 -top-24 w-72 h-72 rounded-full bg-gold/20 blur-[100px]" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-16">
          <p className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] uppercase text-gold mb-3">
            <Tag size={13} /> Limited-time offers
          </p>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight">Specials worth a look</h1>
          <p className="text-white/70 text-sm sm:text-base mt-3 max-w-lg">
            Selected offers on school essentials — while promotional pricing lasts.
          </p>
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        {!products ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="bg-white rounded-2xl border border-slate-100 aspect-[3/4] animate-pulse" />
            ))}
          </div>
        ) : products.length === 0 ? (
          <Reveal>
            <div className="bg-white rounded-3xl border border-slate-200/80 p-16 text-center" data-testid="no-specials">
              <p className="font-display font-bold text-navy text-xl">No specials right now</p>
              <p className="text-sm text-slate-500 mt-2">New promotions drop regularly — check back soon.</p>
            </div>
          </Reveal>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5" data-testid="specials-grid">
            {products.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
